import { JsonObject } from '../../app/json/jsonValue.js';
import { GetParentJsonValueHandler } from './getParentJsonValueHandler.js';
import type { ITransientStore } from './iTransientStore.js';

/**
 * Interface for dynamic action providers
 */
export abstract class IAction {
    /**
     * Gets the full type name for DynamicAction operation tracking
     */
    abstract get typeName(): string;

    /**
     * Performs dynamic action on component data
     */
    abstract doAction(
        appSite: string,
        appView: string,
        appFile: string,
        componentName: string,
        resolvedAppSite: string,
        resolvedComponentName: string,
        paramJson: JsonObject,
        componentJson: JsonObject,
        transientStore: ITransientStore,
        actionJson: JsonObject | null,
        getParentJsonValue: GetParentJsonValueHandler | null
    ): void;
}
